import React from 'react';
import styles from './Input.module.css';

// Heredamos todos los atributos estándar de un input HTML
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  isInvalid?: boolean;
}

export const Input: React.FC<InputProps> = ({ isInvalid = false, ...props }) => {
  const inputClasses = `${styles.input} ${isInvalid ? styles.invalid : ''}`;

  return <input className={inputClasses} {...props} />;
};
